// @ts-nocheck
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import {
    chain,
    UpdatePrice as baseUpdatePrice,
    DispatchUpdateWishListLine as baseDispatchUpdateWishListLine,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateUnitOfMeasure";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";

export const UpdatePrice = createChainHandler("UpdatePrice", chain, async props => {
    if (props.reloadAllLines || !props.apiResult || props.apiResult.quoteRequired) {
        return;
    }

    /* Store Custom Code - Start */
    props.dispatch({
        type: "Store/Data/Products/BeginLoadRealTimePrice",
        productId: props.apiResult.productId,
    });
    /* Store Custom Code - End */

    let loadedPricing = false;
    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: [
                {
                    productId: props.apiResult.productId,
                    unitOfMeasure: props.apiResult.unitOfMeasure,
                    qtyOrdered: props.apiResult.qtyOrdered,
                },
            ],
            onComplete: realTimePricingProps => {
                if (realTimePricingProps.apiResult) {
                    props.pricing = realTimePricingProps.apiResult.realTimePricingResults?.find(
                        o => o.productId === props.apiResult.productId,
                    );
                } else if (realTimePricingProps.error) {
                    props.failedToLoadPricing = true;
                }

                loadedPricing = true;
            },
        }),
    );

    await waitFor(() => loadedPricing);
});

replaceInChain(chain, baseUpdatePrice, UpdatePrice);

export const DispatchUpdateWishListLine = createChainHandler("DispatchUpdateWishListLine", chain, async props => {
    if (props.reloadAllLines || !props.apiResult) {
        return;
    }

    props.dispatch({
        type: "Pages/MyListDetails/UpdateUnitOfMeasure",
        wishListLineId: props.apiResult.id,
        unitOfMeasure: props.apiResult.unitOfMeasure,
        pricing: props.pricing,
        inventory: props.inventory,
        failedToLoadPricing: props.failedToLoadPricing,
        failedToLoadInventory: props.failedToLoadInventory,
    });

    props.dispatch({
        type: "Data/WishListLines/UpdateWishListLine",
        model: props.apiResult,
    });

    /* Store Custom Code - Start */
    props.dispatch({
        type: "Store/Data/Products/CompleteLoadRealTimePrice",
        productId: props.apiResult.productId,
    });
    /* Store Custom Code - End */
});

replaceInChain(chain, baseDispatchUpdateWishListLine, DispatchUpdateWishListLine);
